import EmptyIcon from './EmptyDocLight';
import EmptyDarkIcon from './EmptyDocDark';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
import { useTheme } from '@blofin/blofin-ui';

const Empty: FC<{ className?: string; emptyText?: string; themeMode?: 'light' | 'dark'; textClassName?: string }> = ({
  className = '',
  textClassName = '',
  emptyText,
  themeMode,
}) => {
  const { theme } = useTheme();

  const t = useTranslations('common');

  // 优先使用传入的 themeMode，如果没有传入则使用 useTheme() 获取的 theme
  const currentTheme = themeMode || theme;

  return (
    <div className={`flex h-full flex-col items-center justify-center ${className}`}>
      {currentTheme === 'light' ? (
        <EmptyIcon className="h-[72px] w-[72px]" />
      ) : (
        <EmptyDarkIcon className="h-[72px] w-[72px]" />
      )}
      <span
        className={`mt-[24px] text-[16px] leading-[24px] text-light-label-40 dark:text-dark-label-40 ${textClassName}`}
      >
        {emptyText ? emptyText : t('noData')}
      </span>
    </div>
  );
};

export default Empty;
